import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// scss
import "../../styles/components/TournamentNavbar.scss";

function BetaTournamentNavbar({ tournament }) {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [sidebarHasOpened, setSidebarHasOpened] = useState(false);

  useEffect(() => {
    document.body.style.background = "#f0f0f0";

    return () => {
      document.body.style.background = "";
    };
  }, []);

  useEffect(() => {
    document.title = tournament?.name || "Martin's Tournaments";
    window.scrollTo(0, 0);
  }, [tournament]);

  const openSidebar = () => {
    setSidebarHasOpened(true);
    setSidebarActive(true);
  };

  const closeSidebar = () => {
    setSidebarActive(false);
  };

  const links = [
    {
      url: "/",
      name: "Torneos",
      icon: <span className="material-symbols-rounded">trophy</span>,
    },
    {
      url: "/comprar",
      name: "Comprar",
      icon: <span className="material-symbols-rounded">shopping_bag</span>,
    },
  ];

  return (
    <div
      className={`tournamentNavbar tournamentNavbar__${tournament?.pageColorVersion}`}
    >
      <Link to="/" className="hostLogoContainer">
        <img
          src={
            tournament?.hostLogoImage
              ? tournament.hostLogoImage
              : "/GreyMTransparent.png"
          }
          alt="Logo"
          draggable={false}
          className="navbarHostLogo"
        />
      </Link>

      <div className="linksContainer">
        <Link to="/" className="pageLink">
          <span className="material-symbols-rounded">trophy</span>

          <span className="linkText">Más Torneos</span>
        </Link>

        <Link to="/comprar" className="pageLink">
          <span className="material-symbols-rounded">local_mall</span>

          <span className="linkText">Comprar</span>
        </Link>
      </div>

      <div className="dropDownBtnContainer">
        <span className="material-symbols-rounded" onClick={openSidebar}>
          menu
        </span>
      </div>

      <div
        className={[
          "sidebarContainer",
          sidebarActive
            ? "sidebarContainer__active"
            : "sidebarContainer__disabled",
          !sidebarHasOpened ? "sidebarContainer__initial" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="sidebar">
          <div className="sidebarTitleContainer">
            That Dude&apos;s Tournaments
          </div>

          <div className="sidebarLinksContainer">
            {links.map((link) => (
              <Link
                to={link.url}
                className="sidebarLink"
                key={link.url}
                onClick={closeSidebar}
              >
                {link.icon}
                {link.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="background" onClick={closeSidebar} />
      </div>
    </div>
  );
}

export default BetaTournamentNavbar;
